export default "__VITE_ASSET__00a33267__"